export const SUBSCRIPTION_DISCOUNT_VALUE = 30;
